import React, { memo } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import {
  DATE_TYPE,
  DATE_TYPE_OPTIONS,
} from 'apps/spot-quote-control-panel/constants/spotBiddingConfig'
import { ISpotBiddingRule } from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

interface IDateTypeProps {
  value: RecursivePartial<ISpotBiddingRule>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
}

export const DateType = memo<IDateTypeProps>(({ onChange, value }) => {
  const dateTypeHandler = (e: ISelectOption<DATE_TYPE>) => {
    const dateType = e.value
    const emptyRange = {
      rangeStart: undefined,
      rangeEnd: undefined,
    }
    const emptyRangeProximalHour = {
      rangeStart: undefined,
      rangeEnd: undefined,
      dayOrHour: undefined,
    }
    const dateChange: RecursivePartial<ISpotBiddingRule> = {
      isSameDay: dateType === DATE_TYPE.sameDay,
      isWeekend: dateType === DATE_TYPE.weekend,
      isDrop: undefined,
      isMultiStop: undefined,
      geographicCriteria: undefined,
      mileageCriteria: undefined,
      dateCriteria: dateType === DATE_TYPE.dateRange ? emptyRange : undefined,
      proximalHourCriteria: dateType === DATE_TYPE.numDaysOut ? emptyRangeProximalHour : undefined,
    }

    onChange(dateChange)
  }

  const { dateCriteria, isSameDay, isWeekend, proximalHourCriteria } = value

  let ruleType = isSameDay ? DATE_TYPE.sameDay : ''
  if (isWeekend) {
    ruleType = DATE_TYPE.weekend
  } else if (dateCriteria) {
    ruleType = DATE_TYPE.dateRange
  } else if (proximalHourCriteria) {
    ruleType = DATE_TYPE.numDaysOut
  }

  return (
    <div className='col-md-6 col-xs-4'>
      <Select
        label='Date Type'
        options={DATE_TYPE_OPTIONS}
        value={ruleType}
        onChange={dateTypeHandler}
        dataTest='modal-date-type'
        required
        large
      />
    </div>
  )
})
